<template>
  <section class="investment">
      <div class="investment__content container">
        <div class="investment__terms">
          <h1 class="investment__title --key-title --fade-in-right" data-vertical-ivp-class="--animate">A Shiny Investment</h1>
          <div class="investment__lines --fade-in-right" data-vertical-ivp-class="--animate">
            <hr class="line-1"><hr class="line-2">
          </div>
          <div class="investment__consideration --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
            <div class="--image">
              <img src="../assets/investment/mining.png">
            </div>
             <div class="--text">
              <h2><b>01.</b> Mining</h2>
              <p class="investment__description">
                On top of the 800 acres already in the company's resource portfolio, GEMXX recently
                acquired an additional 217 acres of gem-bearing property in Alberta, Canada. Mining
                is where the company focuses many of its proudest ESG efforts, applying safe,
                efficient, and sustainable practices.
              </p>
            </div>
          </div>
          <div class="investment__consideration --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
            <div class="--image">
              <img src="../assets/investment/design.png">
            </div>
             <div class="--text">
              <h2><b>02.</b> Jewelry Design</h2>
              <p class="investment__description">
                GEMXX works with world-renowned jewelry designers to maximize opportunities 
                for creating popular and extremely desirable jewelry. 
              </p>
            </div>
          </div>
          <div class="investment__consideration --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
            <div class="--image">
              <img src="../assets/investment/production.png">
            </div>
             <div class="--text">
              <h2><b>03.</b> Production </h2>
              <p class="investment__description">
                The company produces 100% of its own products. Its five-year plan includes
                acquisitions for essential jewelry resources like gold and silver, granting
                greater control for reducing production costs.
              </p>
            </div>
          </div>
        </div>
        <cta/>
      </div>
  </section>
</template>

<script>
import cta from '@/components/cta.vue';

export default {
  name: 'investment',
  components: {
    cta
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/investment.scss";
</style>
